import React from 'react';
import { Divider } from './GenericDivider.styles';
import StylableComponent from '../StylableComponent';

const GenericDivider = ({ className } : StylableComponent) => (
  <Divider className={className} />
);

export default GenericDivider;
